import { DurationInputArg2 } from 'moment';
import * as moment from 'moment';

export const DEFAULT_DURATION_AMOUNT = 14;
export const DATE_FORMAT = 'YYYY-MM-DD';

export const isDateAfterOrEqualToday = (date: Date): boolean => {
  return moment(date).isAfter(moment());
};
export const isTodayPastThreshold = (
  date: Date,
  thresholdNumber: number = DEFAULT_DURATION_AMOUNT,
  thresholdUnit: DurationInputArg2 = 'days'
): boolean => {
  const expiresDate = moment
    .utc(new Date(date), 'YYYY-MM-DD H:m:s')
    .local()
    .add(thresholdNumber, thresholdUnit);
  const currentDate = moment(new Date());

  return currentDate.isAfter(expiresDate);
};

export const getDate = (value: Date, dateFormat?: string) => {
  if (dateFormat) {
    return moment(value).format(dateFormat);
  }
  return moment(value).format(DATE_FORMAT);
};
export const today = (buildForAutomation?: boolean) => {
  return buildForAutomation ? '[*today*]' : getDate(new Date());
};
export const yesterday = (buildForAutomation?: boolean) => {
  let value = new Date();
  value.setDate(value.getDate() - 1);
  return buildForAutomation ? '[*yesterday*]' : getDate(value);
};

export const tomorrow = (buildForAutomation?: boolean) => {
  let value = new Date();
  value.setDate(value.getDate() + 1);
  return buildForAutomation ? '[*tomorrow*]' : getDate(value);
};

export const thisYear = (buildForAutomation?: boolean) => {
  return buildForAutomation ? '[*thisYear*]' : new Date().getFullYear().toString();
};

export const lastYear = (buildForAutomation?: boolean) => {
  return buildForAutomation ? '[*lastYear*]' : (new Date().getFullYear() - 1).toString();
};
export const startOfWeek = (buildForAutomation?: boolean) => {
  return buildForAutomation ? '[*startOfWeek*]' : moment().startOf('week').format(DATE_FORMAT);
};
export const endOfWeek = (buildForAutomation?: boolean) => {
  return buildForAutomation ? '[*endOfWeek*]' : moment().endOf('week').format(DATE_FORMAT);
};

export const lastWeek = (buildForAutomation?: boolean) => {
  return buildForAutomation ? '[*lastWeek*]' : moment().isoWeek(moment().subtract(1, 'w').week());
};

export const last30Days = (buildForAutomation?: boolean) => {
  return buildForAutomation ? '[*last30Days*]' : moment().subtract(30, 'days').format(DATE_FORMAT);
};

export const startOfLastWeek = (buildForAutomation?: boolean) => {
  return buildForAutomation
    ? '[*startOfLastWeek*]'
    : (lastWeek(false) as moment.Moment).startOf('week').format(DATE_FORMAT);
};

export const endOfLastWeek = (buildForAutomation?: boolean) => {
  return buildForAutomation
    ? '[*endOfLastWeek*]'
    : (lastWeek(false) as moment.Moment).endOf('week').format(DATE_FORMAT);
};

export const startOfMonth = (buildForAutomation?: boolean) => {
  return buildForAutomation ? '[*startOfMonth*]' : moment().startOf('month').format(DATE_FORMAT);
};

export const endOfMonth = (buildForAutomation?: boolean) => {
  return buildForAutomation ? '[*endOfMonth*]' : moment().endOf('month').format(DATE_FORMAT);
};

export const startOfLastMonth = (date = new Date(), buildForAutomation?: boolean) => {
  return buildForAutomation
    ? '[*startOfLastMonth*]'
    : moment(date.setDate(0)).startOf('month').format(DATE_FORMAT);
};

export const endOfLastMonth = (date = new Date(), buildForAutomation?: boolean) => {
  return buildForAutomation
    ? '[*endOfLastMonth*]'
    : moment(date.setDate(0)).endOf('month').format(DATE_FORMAT);
};
